
const foojiDomain = import.meta.env.FOOJI_DOMAIN as string;
const authApiBaseUrl = `https://${
  import.meta.env.FOOJI_AUTH_API_SUBDOMAIN as string
}.${foojiDomain}`;

export const assessTurnstile = async (token: string): Promise<any> => {
  const url = `${authApiBaseUrl}/assess-turnstile`;
  const jwt = sessionStorage.getItem("jwt");
  const bearer = `Bearer ${jwt}`;

  console.log("assessTurnstile", { url, token, jwt });

  const result = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: bearer,
    },
    body: JSON.stringify({
      token: token,
    }),
  });
  return await result.json();
};
